// extracted by mini-css-extract-plugin
export var articleAuthor = "article-module--article-author--38b4b";
export var articleHeader = "article-module--article-header--11e87";
export var articleHeaderRow = "article-module--article-header-row--a9bec";
export var articleHeaderText = "article-module--article-header-text--d76f7";
export var articleImage = "article-module--article-image--f1e95";
export var articleImageWrapper = "article-module--article-image-wrapper--e0740";
export var authorImage = "article-module--author-image--38c14";
export var categoryDesc = "article-module--category-desc--05a6c";